import { Box } from '@mui/material';
import {
  Print as PrintIcon,
  CleaningServices as ResetIcon,
  Assessment as SearchIcon,
  TableChart as ExcelIcon,
} from '@mui/icons-material';
import { CustomButton } from '../../../common/components';

const ProjectedReportActions = ({
  onReset,
  onGenerate,
  onExport,
  onExportExcel,
  exportDisabled,
  isExporting,
  isExportingExcel,
}) => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'flex-end' }}>
    <CustomButton variant="warning" startIcon={<ResetIcon />} onClick={onReset} size="small">
      Limpiar
    </CustomButton>
    <CustomButton variant="base" startIcon={<SearchIcon />} onClick={onGenerate} size="small">
      Generar informe
    </CustomButton>
    <CustomButton
      variant="success"
      startIcon={<ExcelIcon />}
      size="small"
      disabled={exportDisabled}
      onClick={onExportExcel}
    >
      {isExportingExcel ? 'Generando...' : 'Exportar Excel'}
    </CustomButton>
    <CustomButton
      variant="info"
      startIcon={<PrintIcon />}
      size="small"
      disabled={exportDisabled}
      onClick={onExport}
    >
      {isExporting ? 'Generando...' : 'Exportar PDF'}
    </CustomButton>
  </Box>
);

export default ProjectedReportActions;
